<template>
  <v-use-mask
    v-if="isMaskEnabled"
    :enabled="maskProps?.enabled"
    :shape="maskShape"
    :container-style="layerStyles"
    :position-x="maskProps?.positionX || 0"
    :position-y="maskProps?.positionY || 0"
    :background-color="maskProps?.showBackground ? maskProps?.backgroundColor : null"
    :shadow="maskProps?.shadow"
    :mask-aspect-ratio="maskProps?.maskAspectRatio || 1"
    :object-fit="objectFit"
  >
    <slot />
  </v-use-mask>
  <div v-else :style="noMaskStyles">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import VUseMask from '../../../vendor/VUseMask/VUseMask.vue';
import { useMediaMask } from "../composables/useMediaMask";

interface MaskProps {
  shape?: string;
  enabled?: boolean;
  positionX?: number;
  positionY?: number;
  backgroundColor?: string;
  showBackground?: boolean;
  shadow?: {
    enabled?: boolean;
    blur?: number;
    offsetX?: number;
    offsetY?: number;
    color?: string;
    opacity?: number;
  };
  align?: string;
  maskAspectRatio?: number;
}

interface Props {
  // Объект со всеми вычислениями из useMediaCard
  mediaCardState: ReturnType<(...args: any[]) => any>;
  maskProps?: MaskProps;
  objectFit?: "cover" | "contain";
}

const props = defineProps<Props>();

const { maskShape, hasMask: hasMaskFromProps, isMaskEnabled } = useMediaMask(
  computed(() => props.maskProps)
);

/**
 * Стили для контейнера маски - используем готовые стили из composable
 */
const layerStyles = computed(() => {
  if (!props.mediaCardState?.maskStyles) return {};
  return props.mediaCardState.maskStyles.value || {};
});

/**
 * Стили для контейнера без маски (обрезает контент по размеру)
 */
const noMaskStyles = computed(() => {
  return {
    width: "100%",
    // contain: auto so ObjectFitLayer's aspect-ratio determines height
    // cover: 100% to fill the container
    height: props.objectFit === "contain" ? "auto" : "100%",
    overflow: "hidden",
    ...(props.mediaCardState?.maskStyles?.value || {}),
  };
});
</script>

<style scoped>
div {
  width: 100%;
  overflow: hidden;
}
@container (max-width: 719px) {
  div { height: auto !important; max-height: unset !important; }
}
</style>

